import { ArrowRight, ClipboardCheck, FileText, MessagesSquare, PenLine, Sparkles, Target, UserRound } from "lucide-react";

const sources = [
  { icon: Sparkles, label: "Ervaringen" },
  { icon: ClipboardCheck, label: "Opdrachten" },
  { icon: FileText, label: "Testen" },
  { icon: PenLine, label: "Reflecties" },
  { icon: MessagesSquare, label: "Gesprekken" },
];

const GrowingProfileSection = () => (
  <section className="py-24 lg:py-32 animate-on-scroll">
    <div className="container mx-auto max-w-6xl px-4 sm:px-6">
      <div className="max-w-2xl mx-auto text-center mb-14">
        <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-accent rounded-full">
          Het resultaat groeit mee
        </span>
        <h2 className="text-3xl lg:text-[2.6rem] font-extrabold text-secondary leading-tight [text-wrap:balance]">
          Geen losse uitslag, maar een steeds rijker leerlingbeeld.
        </h2>
      </div>

      <div className="grid items-center gap-6 lg:grid-cols-[1fr_auto_1fr_auto_1fr]">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-1">
          {sources.map((s) => (
            <div key={s.label} className="flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-3 shadow-soft">
              <s.icon className="w-4 h-4 text-primary" />
              <span className="text-sm font-bold text-secondary">{s.label}</span>
            </div>
          ))}
        </div>
        <ArrowRight className="mx-auto w-6 h-6 rotate-90 text-primary lg:rotate-0" />
        <div className="rounded-3xl bg-gradient-to-br from-primary to-[hsl(212,90%,48%)] p-8 text-center text-primary-foreground shadow-large">
          <UserRound className="mx-auto w-10 h-10" />
          <h3 className="mt-4 text-xl font-extrabold">Leerlingbeeld &amp; LOB-dossier</h3>
          <p className="mt-2 text-sm text-primary-foreground/85">Bouwt op over meerdere leerjaren.</p>
        </div>
        <ArrowRight className="mx-auto w-6 h-6 rotate-90 text-primary lg:rotate-0" />
        <div className="rounded-3xl border border-border bg-card p-8 text-center shadow-soft">
          <Target className="mx-auto w-10 h-10 text-warm" />
          <h3 className="mt-4 text-xl font-extrabold text-secondary">Betere keuzes</h3>
          <p className="mt-2 text-sm text-muted-foreground">Profiel, vakken en vervolgopleiding — onderbouwd door de leerling.</p>
        </div>
      </div>
    </div>
  </section>
);

export default GrowingProfileSection;
